export const ARENA = 'arena';
export const QUEST = 'quest';
export const ALLIANCE_QUEST = 'alliance-quest';
export const ALLIANCE_WAR = 'alliance-war';
export const ALLIANCE_WAR_ATTACK = 'alliance-war-attack';
export const ALLIANCE_WAR_DEFENSE = 'alliance-war-defense';



// WEBPACK FOOTER //
// ./src/data/ids/roles.js